import { useState } from 'react'
import { useSmartTranslation } from '../../../generic/hooks/useSmartTranslation'
import { SmartDialog } from '../../../generic/utilities/SmartDialog'
import NextJob from './NextJob'
import { apiPost } from '../../../generic/Api_Functions'
import { useUser } from '../../../generic/hooks/useUser'

/**
 * @param {Object} props
 * @param {boolean} props.setOpen Boolean value to show or hide dialog
 * @param {Function} props.cancelCallback Function to be called when the dialog is closed
 * @param {String} props.partCode Part code
 * @param {number} props.partId Part Id
 * @returns
 */
const NextJobDialog = ({ setOpen, cancelCallback, partCode, partId }) => {
  const [currentLinkedJobReference, setCurrentLinkedJobReference] = useState(null)
  const { user } = useUser()

  const { t_ } = useSmartTranslation()
  const onNextJobAccept = async (nextLinkedJob) => {
    if (!nextLinkedJob) {
      return
    }

    await apiPost('partWorkflowHistory/nextJob/' + partId + '/' + currentLinkedJobReference.jobReference.id + '/' + user.id)
    cancelCallback()
  }

  return (
    <div>
      <SmartDialog
        setOpen={setOpen}
        acceptCallback={() => onNextJobAccept(currentLinkedJobReference)}
        cancelCallback={cancelCallback}
        title={{ render: partCode }}
        autoClose={false}
        message={t_('Select next job to be done')}
        renderComponent={<NextJob partId={partId} setCurrentLinkedJobReference={(linkedJob) => setCurrentLinkedJobReference(linkedJob)} />}
      />
    </div>
  )
}

export default NextJobDialog
